import { Component, Input } from '@angular/core';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzSizeLDSType } from 'ng-zorro-antd/core/types';
import { NzLayoutModule } from 'ng-zorro-antd/layout';

@Component({
  selector: 'loader-lock-screen',
  standalone: true,
  imports: [NzSpinModule, NzLayoutModule],
  template: `
    <nz-layout>
      <nz-spin [nzSize]="size">
        <img
          width="50%"
          style="max-width: 300px;"
          src="assets/images/logo.png"
          alt="Suprema logo"
        />
      </nz-spin>
    </nz-layout>
  `,
  styles: [
    `
      .ant-spin-blur {
        opacity: 1 !important;
      }
      nz-layout {
        background: rgba(0, 0, 0, 0.5);
        position: fixed;
        top: 0;
        left: 0;
        z-index: 999999;
        width: 100vw;
        height: 100vh;
        align-items: center;
        justify-content: center;
        nz-spin {
          text-align: center;
        }
      }
    `,
  ],
})
export class LockScreenLoaderComponent {
  @Input() size: NzSizeLDSType = 'large';
}
